import http from '@/config/api';

export default {
  updateUserAccount(_, payload) {
    return http.post('/account', payload);
  },
};
